import(/* webpackMode: "eager" */ "/var/www/xhub/frontend/live/components/shared/Footer/index.tsx");
import(/* webpackMode: "eager" */ "/var/www/xhub/frontend/live/components/shared/Header/index.tsx");
import(/* webpackMode: "eager" */ "/var/www/xhub/frontend/live/node_modules/next/dist/client/link.js")